import { gql } from "@apollo/client";

export const INSURANCE_PLANS = gql`
  query InsurancePlans(
    $where: InsurancePlanWhereInput
    $take: Int
    $skip: Int
    $isIn: JSONObject
    $like: InsurancePlanWhereInput
    $orderBy: [InsurancePlanWhereInput]
  ) {
    insurancePlans(
      where: $where
      take: $take
      skip: $skip
      isIn: $isIn
      like: $like
      orderBy: $orderBy
    ) {
      data {
        id
        name
        alias
        icon
        description
        fields
        active
        commissions {
          id
          type
          value
          withholding
        }
      }
      count
    }
  }
`;

export const INSURANCE_PLAN = gql`
  query InsurancePlan($where: InsurancePlanWhereInput) {
    insurancePlan(where: $where) {
      id
      name
      alias
      icon
      description
      active
      params {
        id
        minAge
        maxAge
        deltaStart
        deltaEnd
        deltaStartRIA
        deltaEndRIA
        socialRegimes
        exerciseFrame
      }
      needs {
        id
        hospitalization
        medicalExpenses
        optical
        dental
        hearingAid
        alternativeMedicine
      }
      fields
      startDate
      endDate
      commissions {
        id
        type
        value
        withholding
      }
      attachments {
        id
        type
        contentType
        name
        filename
      }
    }
  }
`;

const products = { INSURANCE_PLANS, INSURANCE_PLAN };

export default products;
